document.addEventListener("DOMContentLoaded", function () {
    let allData = [];
    let totalPages = 1;
    let requests = [];

    function fetchAllXML() {
        let url = `/pages/products-feed?page=1`;

        fetch(url)
            .then(response => response.text())
            .then(xmlText => {
                let parser = new DOMParser();
                let xmlDoc = parser.parseFromString(xmlText.trim(), "application/xml");

                let totalPagesAttr = xmlDoc.documentElement.getAttribute("total_pages");
                if (totalPagesAttr) {
                    totalPages = parseInt(totalPagesAttr, 10);
                    console.log(`🟢 Total pages detected: ${totalPages}`);
                } else {
                    console.error("🔴 Error: total_pages attribute missing in XML.");
                    return;
                }

                // Ielādē pirmo lapu un sagatavo pārējos pieprasījumus
                processXML(xmlText);
                for (let i = 2; i <= totalPages; i++) {
                    requests.push(fetch(`/pages/products-feed?page=${i}`).then(res => res.text()));
                }

                // Apstrādā visus atlikušos lapu pieprasījumus paralēli
                Promise.all(requests).then(responses => {
                    responses.forEach(response => processXML(response));
                    console.log("✅ All pages loaded. Generating final XML...");
                    generateFinalXML();
                });
            })
            .catch(error => console.error("🔴 XML Fetch Error:", error));
    }

    function processXML(xmlText) {
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(xmlText.trim(), "application/xml");

        let items = xmlDoc.querySelectorAll("item_data");
        items.forEach(item => allData.push(item.outerHTML));
        console.log(`📄 Page processed, total items so far: ${allData.length}`);
    }

    function generateFinalXML() {
        let finalXML = `<?xml version="1.0" encoding="UTF-8"?>\n<DataFeeds>\n` + allData.join("\n") + `\n</DataFeeds>`;
        
        console.log(`✅ Final XML generated with ${allData.length} items!`);

        let blob = new Blob([finalXML], { type: "application/xml" });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "shopify_products_feed.xml";
        link.click();
    }

    fetchAllXML();
});
